import { useMediaQuery, useTheme } from '@material-ui/core';
import { useMemo } from 'react';
import { Product } from 'src/graphql';
import { getAllQueryParams } from 'src/helpers/queryparam';

const useSortProducts = (products: Product[]) => {
  const theme = useTheme();
  const isMobileLayout = useMediaQuery(theme.breakpoints.down('xs'));

  const { promoted } = getAllQueryParams() as { promoted: string | string[] };

  const sortedProducts = useMemo(() => {
    if (!isMobileLayout) {
      return products;
    }
    const promotedProducts: Product[] = [];
    const otherProducts: Product[] = [];
    const isPromoted = (code: Product['code']) => {
      if (Array.isArray(promoted)) {
        return promoted.includes(code);
      }
      return code === promoted;
    };
    for (const product of products) {
      isPromoted(product.code)
        ? promotedProducts.push(product)
        : otherProducts.push(product);
    }
    return [...promotedProducts, ...otherProducts];
  }, [isMobileLayout, products, promoted]);

  return sortedProducts;
};

export default useSortProducts;
